import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { iconStatusError, iconStatusInfo, iconStatusSuccess, iconStatusWarning } from '@tesla/design-system-icons';
import cx from 'classnames';
import React from 'react';
import { Icon } from '../icon/icon.js';
var iconStatusMap = {
  error: React.createElement(Icon, {
    data: iconStatusError
  }),
  info: React.createElement(Icon, {
    data: iconStatusInfo
  }),
  success: React.createElement(Icon, {
    data: iconStatusSuccess
  }),
  warning: React.createElement(Icon, {
    data: iconStatusWarning
  })
};
export var StatusMessage = function StatusMessage(_ref) {
  var body = _ref.body,
      className = _ref.className,
      _ref$enclosed = _ref.enclosed,
      enclosed = _ref$enclosed === void 0 ? true : _ref$enclosed,
      header = _ref.header,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["body", "className", "enclosed", "header", "type"]);

  var typeIcon = type ? iconStatusMap[type] : null;
  return React.createElement("div", _objectSpread({
    className: cx('tds-status_msg', {
      'tds-card tds-card--dense': enclosed
    }, className),
    role: "status"
  }, rest), typeIcon, React.createElement("div", {
    className: "tds-card-body"
  }, header && React.createElement("div", {
    className: "tds-text--h6"
  }, header), body && React.createElement("div", null, body)));
};